import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authService } from '../services/authService';
import { useAuthStore } from '../store/authStore';
import { useToastStore } from '../store/toastStore';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { FormField } from '../components/ui/FormField';
import { AuthLayout } from '../components/layout/AuthLayout';

const BENEFITS = [
  { label: 'Pedidos na palma da mão', description: 'Acompanhe o status de tudo o que você comprou' },
  { label: 'Compra rápida e segura', description: 'Seus dados protegidos em todas as etapas' },
  { label: 'Ofertas exclusivas', description: 'Novidades e promoções para quem já é da família' },
];

export function LoginPage() {
  const navigate = useNavigate();
  const login = useAuthStore((s) => s.login);
  const showToast = useToastStore((s) => s.show);

  const [credential, setCredential] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.SubmitEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await authService.login({ credential, password });
      login(data.accessToken, data.customerId, data.name, data.canManageStoreSettings);
      navigate('/');
    } catch (err: any) {
      showToast(err?.response?.data?.errors?.[0] ?? 'Credenciais inválidas.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      heading={<>Bem-vinda<br /><span className="text-chocolate">de volta</span></>}
      description="Entre na sua conta e acompanhe seus pedidos com facilidade, a qualquer hora e em qualquer lugar."
      benefits={BENEFITS}
    >
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-text-dark mb-1">Entrar</h1>
        <p className="text-text-light text-sm">
          Use seu e-mail ou telefone para acessar sua conta
        </p>
      </div>

      <form onSubmit={handleSubmit} className="flex flex-col gap-5">
        <FormField label="E-mail ou telefone" required>
          <Input
            type="text"
            value={credential}
            onChange={(e) => setCredential(e.target.value)}
            placeholder="exemplo@email.com ou 85994322348"
            required
            autoComplete="username"
          />
        </FormField>

        <FormField label="Senha" required>
          <Input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            required
            autoComplete="current-password"
          />
        </FormField>

        <div className="text-right">
          <Link to="/esqueci-senha" className="text-chocolate hover:underline text-sm">
            Esqueci minha senha
          </Link>
        </div>

        <Button type="submit" fullWidth loading={loading} size="lg" className="mt-1">
          Entrar
        </Button>
      </form>

      <p className="text-center text-sm text-text-light mt-6">
        Primeira vez?{' '}
        <Link to="/cadastro" className="text-chocolate font-medium hover:underline">
          Criar acesso
        </Link>
      </p>
    </AuthLayout>
  );
}
